module.exports = __webpack_public_path__ + "img/CAL-IEC-Accessory.d29769f6.webp";